import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import moment from 'moment'
import SwitchButton from '../../Components/SwitchButton'
import DateTime from 'react-datetime'
import { includes, isObject } from 'lodash'
import OrderActions from '../../Redux/OrderRedux'
import CategoryActions from '../../Redux/CategoryRedux'
import ArrayCleaner from '../../Utils/ArrayCleaner'
import ViewDetail from '../../Containers/Order/ViewDetail'
import ConfirmOrder from '../../Containers/Order/ConfirmOrder'
import ViewPayment from '../../Containers/Order/ViewPayment'
import EditAmount from '../../Containers/Order/EditAmount'
import EditStatus from '../../Containers/Order/EditStatus'
import DownloadOrderList from '../../Containers/Order/DownloadOrderList'
import OrderInvoice from '../../Containers/Order/OrderInvoice'
import ResendVoucher from '../../Containers/Order/ResendVoucher'
import FormatMoney from '../../Utils/FormatMoney'
import { currentBranch, currentRole } from '../../Utils/PrivilegeUtils'

class List extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.orderStatus = [
      { value: 'checkout', label: 'CHECKOUT' },
      { value: 'payment-pending', label: 'PENDING' },
      { value: 'payment-failed', label: 'FAILED' },
      { value: 'canceled', label: 'CANCELED' },
      { value: 'confirmed', label: 'CONFIRMED' },
      { value: 'expired', label: 'EXPIRED' },
      { value: 'approved-cs', label: 'APPROVED CS' }
    ]

    this.orderType = [
      { value: 'all', label: 'ALL' },
      { value: 'modem', label: 'MODEM' },
      { value: 'attraction', label: 'ATTRACTION' },
      { value: 'event', label: 'EVENTS', restriction: ['admin_travy', 'PH'] },
      { value: 'insurance', label: 'INSURANCE', restriction: ['admin_travy', 'PH'] },
      { value: 'inventory', label: 'E-COMMERCE', restriction: ['admin_travy'] },
      { value: 'esim', label: 'ESIM', restriction: ['admin_travy'] },
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.sourceType = [
      { value: '', label: 'ALL' },
      { value: 'ID', label: 'PASSPOD', restriction: ['admin_travy', 'PH'] },
      { value: 'AP', label: 'TRAVYPASS', restriction: ['PH'] }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.order_status = [
      { value: 'request-cancel', label: 'REQUEST CANCEL' }
    ]

    this.payment_methods = [
      { value: '', label: 'ALL' },
      { value: 'bank-transfer', label: 'BANK TRANSFER' },
      { value: 'credit-card', label: 'CREDIT CARD', restriction: ['PH'] },
      { value: 'cod', label: 'COD', restriction: ['ID'] },
      { value: 'virtual-account', label: 'VIRTUAL ACCOUNT', restriction: ['PH'] },
      { value: 'DANA', label: 'DANA', restriction: ['PH'] },
      { value: 'gopay', label: 'GOPAY', restriction: ['PH'] },
      { value: 'ovo', label: 'OVO', restriction: ['PH'] },
      { value: 'kredivo', label: 'KREDIVO', restriction: ['PH'] },
      { value: 'shopeepay', label: 'SHOPEEPAY', restriction: ['PH'] },
      { value: 'qris', label: 'QRIS', restriction: ['PH'] }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.state = {
      showModal: null,
      selected: '',
      filter: {
        code: '',
        page: 1,
        filterDate: false,
        from: moment().subtract(1, 'months'),
        until: moment(),
        status: '',
        type: 'all',
        embed: '',
        inventory_type: '',
        order_status: null,
        q: '',
        transaction_amount_from: null,
        transaction_amount_to: null,
        payment_method: '',
        coupon_code: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchOrder()
    this.props.getCategory()
  }

  _fetchOrder = (filter = { page: 1 }, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    if (this.state.filter.from && this.state.filter.until) {
      params.from = this.state.filter.from.format('Y-MM-DD')
      params.until = this.state.filter.until.format('Y-MM-DD')
    } else {
      params.from = null
      params.until = null
    }
    params.filterDate = null
    this.props.getOrder(params)
  }

  _specialFilterChange = (event, field) => {
    let filter = { ...this.state.filter }
    let value = event.target.value
    filter[field] = value
    this.setState({ filter })
  }

  _productTypeChange = (event) => {
    let filter = { ...this.state.filter }
    let value = event.target.value
    filter.type = value
    if (value !== 'modem') {
      if (filter.embed !== '') {
        filter.embed = ''
        this.setState({ filter })
      } else if (filter.inventory_type !== '') {
        filter.inventory_type = ''
        this.setState({ filter })
      }
    }
    this.setState({ filter })
  }

  _filterChange = (data, field) => {
    const uniq = ['page', 'filterDate', 'from', 'until', 'order_status']
    let val = null
    if (includes(uniq, field)) {
      if (field === 'from' || field === 'until') {
        if (isObject(data)) {
          val = data
        }
      } else {
        val = data
      }
    } else {
      val = data.target.value
    }
    let filter = { ...this.state.filter }
    filter[field] = val
    if (field === 'order_status') {
      filter['status'] = ''
    }
    this.setState({ filter })
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._fetchOrder({ page })
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _select = (data, action) => {
    this.setState({ selected: data })
    this._toggleModal(action)
  }

  render () {
    const { order, category } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Order List
              {(order.fetching || order.processing) &&
                <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {
              currentRole() !== 'cs' &&
              <button className='btn btn-primary' onClick={() => this._toggleModal('download-list')}>Download List</button>
            }
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <form className='form-inline' onSubmit={(event) => this._fetchOrder({ page: 1 }, event)}>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Search</label>
                <input style={{ width: '250px' }} type='text' placeholder='Order Number / Email / Name' className='form-control' value={this.state.filter.q} onChange={(event) => this._filterChange(event, 'q')} />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Amount From:</label>
                <input style={{ width: '180px' }} type='number' placeholder='Input amount' className='form-control' value={this.state.filter.transaction_amount_from || ''} onChange={(event) => this._filterChange(event, 'transaction_amount_from')} />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>To:</label>
                <input style={{ width: '180px' }} type='number' placeholder='Input amount' className='form-control' value={this.state.filter.transaction_amount_to || ''} onChange={(event) => this._filterChange(event, 'transaction_amount_to')} />
              </div>
              {
                currentRole() !== 'admin_travy' &&
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Coupon</label>
                  <input style={{ width: '200px' }} type='text' placeholder='Insert Coupon Code' className='form-control' value={this.state.filter.coupon_code || ''} onChange={(event) => this._filterChange(event, 'coupon_code')} />
                </div>
              }
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Date Range:</label>
                <DateTime
                  value={this.state.filter.from}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'from')}
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                />
                <label className='control-label ml-2 mr-2'>To:</label>
                <DateTime
                  value={this.state.filter.until}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'until')}
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                />
              </div>
              {
                currentRole() !== 'admin_travy' &&
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Status</label>
                  <select disabled={this.state.filter.order_status} className='form-control' value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')}>
                    <option value=''>ALL</option>
                    {this.orderStatus.map((list, i) => (
                      <option key={i} value={list.value}>{list.label}</option>
                    ))}
                  </select>
                </div>
              }
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Product Type</label>
                <select className='form-control' value={this.state.filter.type} onChange={(event) => this._productTypeChange(event)}>
                  {
                    this.orderType.map((list, i) => (
                      <option key={i} value={list.value}>{list.label}</option>
                    ))
                  }
                </select>
              </div>
              {
                currentBranch() !== 'PH' &&
                this.state.filter.type === 'modem' &&
                  <div className='form-group mr-2 mb-3'>
                    <label className='control-label mr-2'>Insurance</label>
                    <select className='form-control' value={this.state.filter.embed} onChange={(event) => this._specialFilterChange(event, 'embed')}>
                      <option value=''>ALL</option>
                      <option value='yes'>Included</option>
                      <option value='no'>Excluded</option>
                    </select>
                  </div>
              }
              {
                this.state.filter.type === 'inventory' &&
                  <div className='form-group mr-2 mb-3'>
                    <label className='control-label mr-2'>Category</label>
                    <select className='form-control' value={this.state.filter.inventory_type} onChange={(event) => this._specialFilterChange(event, 'inventory_type')}>
                      <option value=''>ALL</option>
                      {
                        category.data.map((item, i) => (
                          <option key={i} value={item.id}>{item.name.toUpperCase()}</option>
                        ))
                      }
                    </select>
                  </div>
              }
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Payment Method</label>
                <select className='form-control' value={this.state.filter.payment_method} onChange={(event) => this._filterChange(event, 'payment_method')}>
                  {this.payment_methods.map((list, i) => (
                    <option key={i} value={list.value}>{list.label}</option>
                  ))}
                </select>
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Source</label>
                <select className='form-control' value={this.state.filter.code} onChange={(event) => this._filterChange(event, 'code')}>
                  {
                    this.sourceType.map((item, i) => (
                      <option key={i} value={item.value}>{item.label}</option>
                    ))
                  }
                </select>
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Show Request Cancel</label>
                <SwitchButton isChecked={!!this.state.filter.order_status} onChange={() => this._filterChange(!this.state.filter.order_status ? 'request-cancel' : null, 'order_status')} />
              </div>
              <div className='form-group mr-2 mb-2'>
                <button type='submit' className='btn btn-primary'>Apply Filter</button>
              </div>
            </form>
          </div>
        </header>
        <section className='section' style={{ width: '225%' }}>
          <div className='card'>
            {!(order.fetching || order.processing) && order.err &&
              <div className='alert alert-danger'>{order.err}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th style={{ minWidth: '125px' }}>Order Number</th>
                    <th style={{ minWidth: '125px' }}>Status</th>
                    <th style={{ minWidth: '125px' }}>Confirmation Date</th>
                    <th style={{ minWidth: '125px' }}>Waiting Voucher</th>
                    <th style={{ minWidth: '125px' }}>Cancellation</th>
                    <th style={{ minWidth: '125px' }}>User Destination</th>
                    <th style={{ minWidth: '125px' }}>Name</th>
                    <th style={{ minWidth: '125px' }}>Phone Number</th>
                    <th style={{ minWidth: '125px' }}>Email</th>
                    <th style={{ minWidth: '125px' }} width='5%'>Create Date</th>
                    <th style={{ minWidth: '125px' }}>Payment Method</th>
                    <th style={{ minWidth: '125px' }}>Unique Number</th>
                    <th style={{ minWidth: '125px' }}>Currency</th>
                    <th style={{ minWidth: '125px' }}>Total Deposit</th>
                    <th style={{ minWidth: '125px' }}>Admin Fee</th>
                    <th style={{ minWidth: '125px' }}>Total Amt</th>
                    <th style={{ minWidth: '125px' }}>Coupon Code</th>
                    <th style={{ minWidth: '125px' }}>Discount Amt</th>
                    <th style={{ minWidth: '125px' }}>Final Amt</th>
                    <th style={{ minWidth: '125px' }}>User Access From</th>
                    {
                      ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                      <th className='text-center'>Edit Amount</th>
                    }
                    {
                      currentRole() !== 'admin_travy' &&
                      <th className='text-center'>View Order Details</th>
                    }
                    {
                      currentRole() !== 'admin_travy' &&
                      <th className='text-center'>View Payment and Other Details</th>
                    }
                    {
                      ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                      <th className='text-center'>Confirm Order</th>
                    }
                    {
                      ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                      <th className='text-center'>Download Invoice</th>
                    }
                    {
                      currentRole() === 'admin' &&
                      <th className='text-center'>Resend Voucher</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    order.data && (order.data.data && order.data.data.length)
                      ? order.data.data.map((item, i) => {
                        let name = []
                        name.push(item.salutation)
                        name.push(item.first_name)
                        name.push(item.last_name)
                        name = ArrayCleaner(name)

                        let requestCancel = null
                        if (item.order_details && item.order_details.length > 0) {
                          item.order_details.map((detail, i) => {
                            if (detail.order_detail_status) {
                              requestCancel = detail.order_detail_status
                            }
                            return requestCancel
                          })
                        }

                        return (
                          <tr key={i}>
                            <td>{ item.order_number || '-' }</td>
                            <td>
                              { item.status || '-' }
                              {
                                ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                                ['payment-pending', 'payment-failed', 'expired'].indexOf(item.status) >= 0 &&
                                <button className='btn btn-primary btn-sm' onClick={() => this._select(item, 'edit-status')}>
                                  <i className='fa fa-edit' />
                                </button>
                              }
                            </td>
                            <td>
                              {
                                item.confirm_date !== null
                                  ? moment(item.confirm_date).format(this.dateFormat)
                                  : '-'
                              }
                            </td>
                            <td style={{ textAlign: 'center`' }}>
                              { item.waiting_voucher || '-' }
                            </td>
                            <td style={{ textAlign: 'center' }}>{ requestCancel || '-' }</td>
                            <td>
                              {
                                item.user_destination && item.user_destination.length > 0 ? item.user_destination.toString() : '-'
                              }
                            </td>
                            <td>{ name.join(' ') }</td>
                            <td>{ item.phone_number || '-' }</td>
                            <td>{ item.email || '-' }</td>
                            <td>{ moment.unix(item.created_at).format(this.dateFormat) || '-' }</td>
                            <td>{ (item.order_payments && item.order_payments.length) ? item.order_payments[item.order_payments.length - 1].payment_method : '-' }</td>
                            <td>{ item.unique_number }</td>
                            <td>{ item.currency_code }</td>
                            <td className='text-right'>
                              { FormatMoney(item.total_deposit_amount) }
                            </td>
                            <td className='text-right'>
                              { FormatMoney(item.total_admin_fee) }
                            </td>
                            <td className='text-right'>
                              { FormatMoney(item.total_amount) }
                            </td>
                            <td style={{ textAlign: 'center' }}>{ item.coupon_code || '-' }</td>
                            <td className='text-right'>
                              { FormatMoney(item.discount_amount) }
                            </td>
                            <td className='text-right'>
                              { FormatMoney(item.final_amount) }
                            </td>
                            <td>{ item.userdevice }</td>
                            {
                              ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                              <td className='text-center'>
                                {(includes(['payment-pending', 'confirmed', 'expired'], item.status))
                                  ? <button className='btn btn-primary' onClick={() => this._select(item, 'edit-amount')}>
                                    <i className='fa fa-edit' />
                                  </button>
                                  : '-'
                                }
                              </td>
                            }
                            {
                              ['admin', 'finance', 'cs'].indexOf(currentRole()) >= 0 &&
                              <td className='text-center'>
                                <button className='btn btn-primary' onClick={() => this._select(item, 'view-detail')}>
                                  <i className='fa fa-eye' />
                                </button>
                              </td>
                            }
                            {
                              ['admin', 'finance', 'cs'].indexOf(currentRole()) >= 0 &&
                              <td className='text-center'>
                                <button className='btn btn-primary' onClick={() => this._select(item, 'view-payment')}>
                                  <i className='fa fa-list-alt' />
                                </button>
                              </td>
                            }
                            {
                              ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                              <td className='text-center'>
                                { includes(['payment-pending', 'expired'], item.status)
                                  ? <button className='btn btn-primary' onClick={() => this._select(item, 'confirm-order')}>
                                    <i className='fa fa-check-square' /> Confirm
                                  </button>
                                  : '-'
                                }
                              </td>
                            }
                            {
                              ['admin', 'finance'].indexOf(currentRole()) >= 0 &&
                              <td className='text-center'>
                                {
                                  includes(['confirmed'], item.status)
                                    ? <button className='btn btn-primary' onClick={() => this._select(item, 'order-invoice')}>
                                      <i className='fa fa-download' />
                                    </button>
                                    : '-'
                                }
                              </td>
                            }
                            {
                              currentRole() === 'admin' &&
                              <td className='text-center'>
                                {
                                  includes(['confirmed'], item.status)
                                    ? <button className='btn btn-primary' onClick={() => this._select(item, 'resend-email')}>
                                      <i className='fa fa-envelope' />
                                    </button>
                                    : '-'
                                }
                              </td>
                            }
                          </tr>
                        )
                      })
                      : <tr>
                        <td colSpan='25' className='text-center'>- No Data -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-detail'} onClose={this._toggleModal} closeOnOverlayClick>
          <ViewDetail order_id={this.state.selected.id} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-payment'} onClose={this._toggleModal} closeOnOverlayClick>
          <ViewPayment order_id={this.state.selected.id} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'confirm-order'} onClose={this._toggleModal} closeOnOverlayClick>
          <ConfirmOrder detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-amount'} onClose={this._toggleModal} closeOnOverlayClick>
          <EditAmount detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-status'} onClose={this._toggleModal} closeOnOverlayClick>
          <EditStatus detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'download-list'} onClose={this._toggleModal} closeOnOverlayClick>
          <DownloadOrderList closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'order-invoice'} onClose={this._toggleModal} closeOnOverlayClick>
          <OrderInvoice detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'resend-email'} onClose={this._toggleModal} closeOnOverlayClick>
          <ResendVoucher detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        <section className='text-center'>
          {(order.data && order.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={order.data.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={order.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order,
  detail: state.detail,
  category: state.category
})

const dispatchToProps = (dispatch) => ({
  getOrder: (filter) => dispatch(OrderActions.orderRequest(filter)),
  getCategory: () => dispatch(CategoryActions.getCategoryRequest()),
  resendOrderVoucher: (data) => dispatch(OrderActions.resendOrderVoucherRequest(data))
})

export default connect(stateToProps, dispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/Pages/Order/List.js